export interface NormalizedPrice {
  amount: number
  currency: string
  inOre: boolean
}

interface RawPrice {
  amount: number
  currency_code?: string
}

export function normalizePrice(
  price: RawPrice | number | undefined | null,
  defaultCurrency = 'NOK',
  isOre = false,
): NormalizedPrice {
  if (!price) {
    return {
      amount: 0,
      currency: defaultCurrency,
      inOre: isOre,
    }
  }

  const amount = typeof price === 'number' ? price : price.amount
  const currency =
    typeof price === 'number' ? defaultCurrency : price.currency_code || defaultCurrency

  // Convert øre to kroner if needed
  const normalizedAmount = isOre ? amount / 100 : amount

  return {
    amount: normalizedAmount,
    currency,
    inOre: isOre,
  }
}

export function normalizeTicketPrice(price: RawPrice | number | undefined | null): NormalizedPrice {
  return normalizePrice(price, 'NOK', false) // Ticket prices are in kroner
}

export function normalizeEquipmentPrice(
  price: RawPrice | number | undefined | null,
): NormalizedPrice {
  return normalizePrice(price, 'NOK', true) // Equipment prices are in øre
}

export function normalizeSeatPrice(price: number | undefined | null): NormalizedPrice {
  return normalizePrice(price ? { amount: price, currency_code: 'NOK' } : null, 'NOK', true) // Seat prices are in øre
}

export function formatNormalizedPrice(price: NormalizedPrice | null | undefined): string {
  if (!price || typeof price.amount !== 'number') {
    return '0,-'
  }
  // Convert øre to kroner if needed
  const displayAmount = price.inOre ? price.amount / 100 : price.amount
  return `${displayAmount.toFixed(0)}${price.currency === 'NOK' ? ',-' : ` ${price.currency}`}`
}
